import React from 'react'

import { InvitationRedirector } from './InvitationRedirector'
import { RedirectorProps, RedirectorVariant } from './Redirector.type'
import { SeamlessTransitionRedirector } from './SeamlessTransitionRedirector'
import { ShortUrlRedirector } from './ShortUrlRedirector'

export const Redirector: React.FC<RedirectorProps> = props => {
  switch (props.variant) {
    case RedirectorVariant.SHORT_URL:
      return <ShortUrlRedirector shortUrl={props.shortUrl} />
    case RedirectorVariant.INVITATION:
      return <InvitationRedirector invitationKey={props.invitationKey} />
    case RedirectorVariant.SEAMLESS:
      return (
        <SeamlessTransitionRedirector
          config={props.config}
          selectedItem={props.selectedItem}
          source={props.source}
        />
      )
    default: {
      // Exhaustiveness guard: if a variant is added without a case above, this
      // assignment fails to compile. At runtime, render nothing.
      const unhandled: never = props
      void unhandled
      return null
    }
  }
}
